// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"4b2ba434","511":"1774f41b","905":"5d57d08d","971":"b0135c69"}[chunkId] + ".chunk.js";
};